import Achievements from "./Achievements";
import Header from "./Header";
import Footer from "./Footer";

function App() {
  return (
    <>
      <Achievements></Achievements>
    </>
  );
}

export default App;
